import { HStack, Box, Text, Input, VStack, IconButton } from '@chakra-ui/react'
import { DeleteIcon } from '@chakra-ui/icons'

// Módulo de calificación
const Score = ({
  title,
  score,
  setScore,
  name,
  editableTitle = false,
  onTitleChange,
  onDelete
}) => {
  const colors = (score, index) => {
    if (score >= index) {
      return { back: '#36355F', font: '#FFFFFF' }
    } else {
      return { back: '#E6E6EF', font: '#36355F' }
    }
  }

  return (
    <Box rounded={'lg'} bg={'#FFF'} w={['90%', '30%', '30%']} boxShadow={'md'} p={2}>
      <HStack justify="space-between" align="start" mb={2}>
        {editableTitle ? (
          <Input
            size="sm"
            value={title}
            onChange={(e) => onTitleChange?.(e.target.value)}
            placeholder="Nombre del punto"
          />
        ) : (
          <Text fontSize="14px" fontWeight="bold" color="#36355F" pl={2}>
            {title}
          </Text>
        )}
        {onDelete ? (
          <IconButton
            size="sm"
            aria-label="Eliminar punto"
            icon={<DeleteIcon />}
            onClick={onDelete}
          />
        ) : null}
      </HStack>
      <HStack justify={'space-between'} align="center" my={7} p={2}>
        <VStack>
          <Box
            as="button"
            px={3}
            py={1}
            w={['40px', '40px', '40px', '40px', '70px']}
            bg={colors(score, 1).back}
            borderRadius="lg"
            display="flex"
            onClick={() => setScore(name, 1)}
          >
            <Text fontSize="13px" color={colors(score, 1).font} m="auto">
              1
            </Text>
          </Box>
          <Text fontSize="7px" color="#36355F" fontWeight="bold" m="auto">
            Malo
          </Text>
        </VStack>
        <VStack>
          <Box
            as="button"
            px={3}
            py={1}
            w={['40px', '40px', '40px', '40px', '70px']}
            bg={colors(score, 2).back}
            borderRadius="lg"
            display="flex"
            onClick={() => setScore(name, 2)}
          >
            <Text fontSize="13px" color={colors(score, 2).font} m="auto">
              2
            </Text>
          </Box>
          <Text fontSize="7px" color="#36355F" fontWeight="bold" m="auto">
            Ineficiente
          </Text>
        </VStack>
        <VStack>
          <Box
            as="button"
            px={3}
            py={1}
            w={['40px', '40px', '40px', '40px', '70px']}
            bg={colors(score, 3).back}
            borderRadius="lg"
            borderStyle={''}
            display="flex"
            onClick={() => setScore(name, 3)}
          >
            <Text fontSize="13px" color={colors(score, 3).font} m="auto">
              3
            </Text>
          </Box>
          <Text fontSize="7px" color="#36355F" fontWeight="bold" m="auto">
            Bueno
          </Text>
        </VStack>
        <VStack>
          <Box
            as="button"
            px={3}
            py={1}
            w={['40px', '40px', '40px', '40px', '70px']}
            bg={colors(score, 4).back}
            borderRadius="lg"
            borderStyle={''}
            display="flex"
            onClick={() => setScore(name, 4)}
          >
            <Text fontSize="13px" color={colors(score, 4).font} m="auto">
              4
            </Text>
          </Box>
          <Text fontSize="7px" color="#36355F" fontWeight="bold" m="auto">
            Muy bueno
          </Text>
        </VStack>
      </HStack>
    </Box>
  )
}

export default Score
